import { render, staticRenderFns } from "./OutingsStatsView.vue?vue&type=template&id=171f2229&scoped=true"
import script from "./OutingsStatsView.vue?vue&type=script&lang=js"
export * from "./OutingsStatsView.vue?vue&type=script&lang=js"
import style0 from "./OutingsStatsView.vue?vue&type=style&index=0&id=171f2229&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171f2229",
  null
  
)

export default component.exports